import { FuseNavigation } from '../../@fuse/types';
import { AppRoutes } from '../gt2/const/AppRoutes';
import { IconsService } from '../gt2/services/icons.service';

const prefix = (localStorage.getItem('PREFIX') || '') + '/';

/** Pastille « PRO » du menu Mise à niveau (bleu pâle / bleu, comme la pastille NEW de PrimeNG). */
export const UPGRADE_PRO_BADGE = { title: 'PRO', bg: '#DBEAFE', fg: '#1D4ED8' };

export const navigation: FuseNavigation[] = [
  {
    id: 'applications',
    title: 'Applications',
    translate: 'NAV.APPLICATIONS',
    type: 'group',
    children: [
      {
        id: 'dashboard-detailed-jul',
        title: 'Tableau de bord',
        translate: 'NAV.DASHBOARD_DETAILED_JUL.TITLE',
        type: 'item',
        icon: 'dashboard_customize',
        url: prefix + AppRoutes.DASHBOARD_INDEX,
      },
      {
        id: 'dashboard',
        title: 'Tableau de bord',
        type: 'item',
        icon: 'dashboard',
        url: prefix + AppRoutes.DASHBOARD_INDEX,
      },
      {
        id: 'dashboard-1',
        title: 'Tableau de bord 1',
        type: 'item',
        icon: 'space_dashboard',
        url: prefix + AppRoutes.DASHBOARD_INDEX1,
      },
      {
        id: 'dashboard-2',
        title: 'Tableau de bord 2',
        type: 'item',
        icon: 'view_quilt',
        url: prefix + AppRoutes.DASHBOARD_INDEX2,
      },
      {
        id: 'dashboard-3',
        title: 'Tableau de bord 3',
        type: 'item',
        icon: 'view_module',
        url: prefix + AppRoutes.DASHBOARD_INDEX3,
      },
      {
        id: 'dashboard-4',
        title: 'Tableau de bord 4',
        type: 'item',
        icon: 'dashboard',
        url: prefix + AppRoutes.DASHBOARD_INDEX4,
      },
      {
        id: 'operations',
        title: 'Opérations',
        type: 'item',
        icon: 'event_note',
        url: prefix + AppRoutes.OPERATIONS,
      },
      {
        id: 'performance',
        title: 'Performance',
        type: 'item',
        icon: 'analytics',
        url: prefix + AppRoutes.DASHBOARD_PERFORMANCE,
      },
      {
        id: 'performance-expert',
        title: 'Performances',
        type: 'item',
        icon: 'analytics',
        url: prefix + AppRoutes.DASHBOARD_PERFORMANCE_EXPERT,
      },
      {
        id: 'dashboard-detailed',
        title: 'Tableau de bord détaillé',
        translate: 'NAV.OPERATIONS.TITLE',
        type: 'item',
        icon: 'dashboard_customize',
        url: prefix + AppRoutes.OPERATIONS,
      },
      {
        id: 'room-management',
        title: 'Gestion des salles',
        translate: 'NAV.ROOM_MANAGEMENT.TITLE',
        type: 'item',
        icon: 'view_timeline',
        url: prefix + AppRoutes.ROOM_MANAGEMENT,
      },
      {
        id: 'congresses',
        title: 'Congrès',
        translate: 'NAV.CONGRESSES.TITLE',
        type: 'item',
        icon: 'groups',
        url: prefix + AppRoutes.CONGRESSES,
      },
      {
        id: 'products',
        title: 'Produits',
        translate: 'NAV.PRODUCTS.TITLE',
        type: 'item',
        // 'icon' : 'restaurant_menu',
        icon: IconsService.getIconStatic('PRODUCT'),
        url: prefix + AppRoutes.PRODUCTS,
      },
      {
        id: 'clients',
        title: 'Clients et entreprises',
        translate: 'NAV.CLIENTS.TITLE',
        type: 'item',
        icon: 'account_circle',
        iconFA: false,
        url: prefix + AppRoutes.CLIENTS,
      },
      {
        id: 'employees',
        title: 'Employés',
        translate: 'NAV.EMPLOYEES.TITLE',
        type: 'item',
        // 'icon' : 'group',
        icon: IconsService.getIconStatic('EMPLOYEES'),
        url: prefix + AppRoutes.EMPLOYEES,
      },
      {
        id: 'reports',
        title: 'Rapports',
        translate: 'NAV.REPORTS.TITLE',
        type: 'item',
        // 'icon' : 'insert_chart',
        icon: IconsService.getIconStatic('REPORT'),
        url: prefix + AppRoutes.REPORTS,
      },
      {
        id: 'materials',
        title: 'Matériels',
        translate: 'NAV.MATERIALS.TITLE',
        type: 'item',
        icon: IconsService.getIconStatic('MATERIAL'),
        url: prefix + AppRoutes.MATERIALS,
      },
      // CORPS MORT (désactivé, à conserver) : entrée de menu « Vente incitative ».
      // Décommenter pour la réafficher.
      /*
      {
        id: 'upsale',
        title: 'Vente incitative',
        translate: 'NAV.UPSALE.TITLE',
        type: 'item',
        // 'icon' : 'restaurant_menu',
        icon: IconsService.getIconStatic('UPSALE'),
        url: prefix + AppRoutes.UPSALE,
      },
      */
      {
        id: 'management',
        title: 'Gestion',
        translate: 'NAV.MANAGEMENT.TITLE',
        type: 'item',
        icon: 'content_paste',
        iconFA: false,
        url: prefix + AppRoutes.MANAGEMENT,
      },
      {
        id: 'venues',
        title: 'Lieux',
        translate: 'NAV.VENUES.TITLE',
        type: 'item',
        icon: IconsService.getIconStatic('PLACE'),
        url: prefix + AppRoutes.VENUES,
      },
      {
        id: 'shops',
        title: 'Boutiques',
        translate: 'NAV.SHOPS.TITLE',
        type: 'item',
        icon: IconsService.getIconStatic('SHOPPING'),
        url: prefix + AppRoutes.SHOPS,
      },
      {
        id: 'submissions',
        title: 'Soumissions',
        translate: 'NAV.SUBMISSIONS.TITLE',
        type: 'item',
        icon: IconsService.SUBMISSION,
        url: prefix + AppRoutes.SUBMISSIONS,
      },
      {
        id: 'settings',
        title: 'Configuration',
        translate: 'NAV.SETTINGS.TITLE',
        type: 'item',
        // 'icon' : 'settings',
        isActiveMatchOptions: 'subset',
        icon: IconsService.getIconStatic('SETTINGS'),
        url: prefix + AppRoutes.SETTINGS, // TODO: replace when bilingual solution and url are sets.
      },
      {
        // Mise à niveau (paywall) : inclus par l'API (navigation_menu) seulement pour un
        // tenant au forfait ESSENTIEL — GOD-only pendant le développement. Les sous-menus
        // « panneau » n'ont pas d'URL : app.component leur rattache leur `function`
        // (les fonctions ne survivent pas au clone JSON de la navigation).
        id: 'upgrade',
        title: 'Mise à niveau',
        translate: 'NAV.UPGRADE.TITLE',
        type: 'collapsable',
        icon: IconsService.getIconStatic('UPGRADE'),
        // Pastille « PRO » (même rendu que la pastille NEW de PrimeNG) à la place d'un « [PRO] » dans le libellé.
        // `classes` : la pastille passe à 10px (styles.scss → .nav-upgrade .nav-link-badge).
        badge: UPGRADE_PRO_BADGE,
        classes: 'nav-upgrade',
        children: [
          {
            // Vue d'ensemble du forfait PRO : panneau (function rattachée dans app.component).
            // Chaque panneau a son bouton « En savoir plus » vers le Centre d'aide.
            id: 'upgrade-features',
            title: 'Fonctionnalités',
            translate: 'NAV.UPGRADE_FEATURES.TITLE',
            type: 'item',
          },
          {
            id: 'upgrade-submissions',
            title: 'Soumission Web',
            translate: 'NAV.UPGRADE_SUBMISSIONS.TITLE',
            type: 'item',
          },
          {
            id: 'upgrade-automations',
            title: 'Automatisations',
            translate: 'NAV.UPGRADE_AUTOMATIONS.TITLE',
            type: 'item',
          },
          {
            id: 'upgrade-integrations',
            title: 'Intégrations',
            translate: 'NAV.UPGRADE_INTEGRATIONS.TITLE',
            type: 'item',
          },
          // IA : sera ajoutée en V2 du paywall (entrée retirée du menu ; l'API ne l'inclut pas non plus).
          // {
          //   id: 'upgrade-ai',
          //   title: 'IA',
          //   translate: 'NAV.UPGRADE_AI.TITLE',
          //   type: 'item',
          // },
          {
            id: 'upgrade-request',
            title: 'Commander',
            translate: 'NAV.UPGRADE_REQUEST.TITLE',
            type: 'item',
            url: prefix + AppRoutes.UPGRADE_REQUEST,
          },
        ],
      },
      {
        id: 'support',
        title: 'Support',
        translate: 'NAV.SUPPORT.TITLE',
        type: 'collapsable',
        // 'icon' : 'help',
        icon: IconsService.getIconStatic('HELP'),
        // 'url'  : '/support',
        children: [
          {
            id: 'contact',
            title: 'Demande de ticket',
            translate: 'NAV.CONTACT.TITLE',
            type: 'item',
            // 'icon' : 'help',
            externalUrl: true,
            openInNewTab: true,
            url: 'https://gestiontraiteur.com/demande-de-ticket/', // prefix+AppRoutes.CONTACT,
          },
          {
            // Centre d'aide V2 (Documentation V2) — visible de tous les rôles
            id: 'help-center',
            title: "Centre d'aide",
            translate: 'NAV.HELP_CENTER.TITLE',
            type: 'item',
            url: prefix + AppRoutes.KB,
          },
          {
            id: 'documentation',
            title: 'Base de connaissance',
            translate: 'NAV.DOCUMENTATION.TITLE',
            type: 'item',
            // 'icon' : 'help',
            url: prefix + AppRoutes.DOCUMENTATION,
          },
          {
            id: 'release-note',
            title: 'Note de mise à jour',
            translate: 'NAV.RELEASE_NOTES.TITLE',
            type: 'item',
            // 'icon' : 'help',
            url: prefix + AppRoutes.RELEASE_NOTES,
          },
        ],
      },
      {
        id: 'platform',
        title: 'Plate-forme',
        translate: 'NAV.PLATFORM.TITLE',
        type: 'collapsable',
        icon: 'smartphone',
        children: [
          {
            id: 'gtphoto-android',
            title: 'GT Photo Android',
            translate: 'NAV.GTPHOTO_ANDROID.TITLE',
            type: 'item',
            icon: 'android',
            externalUrl: true,
            openInNewTab: true,
            url: 'https://play.google.com/store/apps/details?id=com.gt.photo',
          },
          {
            id: 'gtphoto-ios',
            title: 'GT Photo iOS',
            translate: 'NAV.GTPHOTO_IOS.TITLE',
            type: 'item',
            icon: 'phone_iphone',
            externalUrl: true,
            openInNewTab: true,
            url: 'https://apps.apple.com/ca/app/gt-photo-from-mobile-to-shop/id6502609022',
          },
          {
            id: 'rms-magic-link',
            title: 'Recette / Inventaire',
            translate: 'NAV.RMS_MAGIC_LINK.TITLE',
            type: 'item',
            icon: 'launch',
            externalUrl: true,
            openInNewTab: true,
            url: '#',
          },
          {
            id: 'rms-magic-link-livraison',
            title: 'Livraison',
            translate: 'NAV.RMS_MAGIC_LINK_LIVRAISON.TITLE',
            type: 'item',
            icon: 'local_shipping',
            externalUrl: true,
            openInNewTab: true,
            url: '#',
          },
          {
            id: 'roadmap-magic-link',
            title: 'Roadmap',
            translate: 'NAV.ROADMAP_MAGIC_LINK.TITLE',
            type: 'item',
            icon: 'map',
            externalUrl: true,
            openInNewTab: true,
            url: '#',
          },
        ],
      },
    ],
  },
];

export const navigationEn: FuseNavigation[] = [
  {
    id: 'applications',
    title: 'Applications',
    translate: 'NAV.APPLICATIONS',
    type: 'group',
    children: [
      {
        id: 'dashboard-detailed-jul',
        title: 'Dashboard',
        translate: 'NAV.DASHBOARD_DETAILED_JUL.TITLE',
        type: 'item',
        icon: 'dashboard_customize',
        url: prefix + AppRoutes.DASHBOARD_INDEX,
      },
      {
        id: 'dashboard-1',
        title: 'Dashboard 1',
        type: 'item',
        icon: 'space_dashboard',
        url: prefix + AppRoutes.DASHBOARD_INDEX1,
      },
      {
        id: 'dashboard-2',
        title: 'Dashboard 2',
        type: 'item',
        icon: 'view_quilt',
        url: prefix + AppRoutes.DASHBOARD_INDEX2,
      },
      {
        id: 'dashboard-3',
        title: 'Dashboard 3',
        type: 'item',
        icon: 'view_module',
        url: prefix + AppRoutes.DASHBOARD_INDEX3,
      },
      {
        id: 'dashboard-4',
        title: 'Dashboard 4',
        type: 'item',
        icon: 'dashboard',
        url: prefix + AppRoutes.DASHBOARD_INDEX4,
      },
      {
        id: 'operations',
        title: 'Operations',
        type: 'item',
        icon: 'event_note',
        url: prefix + AppRoutes.OPERATIONS,
      },
      {
        id: 'performance',
        title: 'Performance',
        type: 'item',
        icon: 'analytics',
        url: prefix + AppRoutes.DASHBOARD_PERFORMANCE,
      },
      {
        id: 'performance-expert',
        title: 'Performances',
        type: 'item',
        icon: 'analytics',
        url: prefix + AppRoutes.DASHBOARD_PERFORMANCE_EXPERT,
      },
      {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'item',
        icon: 'dashboard',
        url: prefix + AppRoutes.DASHBOARD_INDEX,
      },
      {
        id: 'dashboard-detailed',
        title: 'Advanced Dashboard',
        type: 'item',
        icon: 'dashboard_customize',
        url: prefix + AppRoutes.OPERATIONS,
      },
      {
        id: 'room-management',
        title: 'Room management',
        translate: 'NAV.ROOM_MANAGEMENT.TITLE',
        type: 'item',
        icon: 'view_timeline',
        url: prefix + AppRoutes.ROOM_MANAGEMENT,
      },
      {
        id: 'congresses',
        title: 'Congresses',
        translate: 'NAV.CONGRESSES.TITLE',
        type: 'item',
        icon: 'groups',
        url: prefix + AppRoutes.CONGRESSES,
      },
      {
        id: 'products',
        title: 'Products',
        translate: 'NAV.PRODUCTS.TITLE',
        type: 'item',
        // 'icon' : 'restaurant_menu',
        icon: IconsService.getIconStatic('PRODUCT'),
        url: prefix + AppRoutes.PRODUCTS,
      },
      {
        id: 'clients',
        title: 'Clients and enterprises',
        translate: 'NAV.CLIENTS.TITLE',
        type: 'item',
        icon: 'account_circle',
        iconFA: false,
        url: prefix + AppRoutes.CLIENTS,
      },
      {
        id: 'employees',
        title: 'Employees',
        translate: 'NAV.EMPLOYEES.TITLE',
        type: 'item',
        // 'icon' : 'group',
        icon: IconsService.getIconStatic('EMPLOYEES'),
        url: prefix + AppRoutes.EMPLOYEES,
      },
      {
        id: 'reports',
        title: 'Reports',
        translate: 'NAV.REPORTS.TITLE',
        type: 'item',
        // 'icon' : 'insert_chart',
        icon: IconsService.getIconStatic('REPORT'),
        url: prefix + AppRoutes.REPORTS,
      },
      {
        id: 'materials',
        title: 'Equipments',
        translate: 'NAV.MATERIALS.TITLE',
        type: 'item',
        icon: IconsService.getIconStatic('MATERIAL'),
        url: prefix + AppRoutes.MATERIALS,
      },
      // CORPS MORT (désactivé, à conserver) : entrée de menu « Vente incitative » (EN).
      // Décommenter pour la réafficher.
      /*
      {
        id: 'upsale',
        title: 'Upsale',
        translate: 'NAV.UPSALE.TITLE',
        type: 'item',
        // 'icon' : 'restaurant_menu',
        icon: IconsService.getIconStatic('UPSALE'),
        url: prefix + AppRoutes.UPSALE,
      },
      */
      {
        id: 'management',
        title: 'Management',
        translate: 'NAV.MANAGEMENT.TITLE',
        type: 'item',
        icon: 'content_paste',
        iconFA: false,
        url: prefix + AppRoutes.MANAGEMENT,
      },
      {
        id: 'venues',
        title: 'Places',
        translate: 'NAV.VENUES.TITLE',
        type: 'item',
        icon: IconsService.getIconStatic('PLACE'),
        url: prefix + AppRoutes.VENUES,
      },
      {
        id: 'shops',
        title: 'Shops',
        translate: 'NAV.SHOPS.TITLE',
        type: 'item',
        icon: IconsService.getIconStatic('SHOPPING'),
        url: prefix + AppRoutes.SHOPS,
      },
      {
        id: 'submissions',
        title: 'Submissions',
        translate: 'NAV.SUBMISSIONS.TITLE',
        type: 'item',
        icon: IconsService.SUBMISSION,
        url: prefix + AppRoutes.SUBMISSIONS,
      },
      {
        id: 'settings',
        title: 'Settings',
        translate: 'NAV.SETTINGS.TITLE',
        type: 'item',
        // 'icon' : 'settings',
        isActiveMatchOptions: 'subset',
        icon: IconsService.getIconStatic('SETTINGS'),
        url: prefix + AppRoutes.SETTINGS, // TODO: replace when bilingual solution and url are sets.
      },
      {
        // Mise à niveau (paywall) : inclus par l'API (navigation_menu) seulement pour un
        // tenant au forfait ESSENTIEL — GOD-only pendant le développement. Les sous-menus
        // « panneau » n'ont pas d'URL : app.component leur rattache leur `function`
        // (les fonctions ne survivent pas au clone JSON de la navigation).
        id: 'upgrade',
        title: 'Mise à niveau',
        translate: 'NAV.UPGRADE.TITLE',
        type: 'collapsable',
        icon: IconsService.getIconStatic('UPGRADE'),
        // Pastille « PRO » (même rendu que la pastille NEW de PrimeNG) à la place d'un « [PRO] » dans le libellé.
        // `classes` : la pastille passe à 10px (styles.scss → .nav-upgrade .nav-link-badge).
        badge: UPGRADE_PRO_BADGE,
        classes: 'nav-upgrade',
        children: [
          {
            // Vue d'ensemble du forfait PRO : panneau (function rattachée dans app.component).
            // Chaque panneau a son bouton « En savoir plus » vers le Centre d'aide.
            id: 'upgrade-features',
            title: 'Fonctionnalités',
            translate: 'NAV.UPGRADE_FEATURES.TITLE',
            type: 'item',
          },
          {
            id: 'upgrade-submissions',
            title: 'Soumission Web',
            translate: 'NAV.UPGRADE_SUBMISSIONS.TITLE',
            type: 'item',
          },
          {
            id: 'upgrade-automations',
            title: 'Automatisations',
            translate: 'NAV.UPGRADE_AUTOMATIONS.TITLE',
            type: 'item',
          },
          {
            id: 'upgrade-integrations',
            title: 'Intégrations',
            translate: 'NAV.UPGRADE_INTEGRATIONS.TITLE',
            type: 'item',
          },
          // IA : sera ajoutée en V2 du paywall (entrée retirée du menu ; l'API ne l'inclut pas non plus).
          // {
          //   id: 'upgrade-ai',
          //   title: 'IA',
          //   translate: 'NAV.UPGRADE_AI.TITLE',
          //   type: 'item',
          // },
          {
            id: 'upgrade-request',
            title: 'Commander',
            translate: 'NAV.UPGRADE_REQUEST.TITLE',
            type: 'item',
            url: prefix + AppRoutes.UPGRADE_REQUEST,
          },
        ],
      },
      {
        id: 'support',
        title: 'Support',
        translate: 'NAV.SUPPORT.TITLE',
        type: 'collapsable',
        // 'icon' : 'help',
        icon: IconsService.getIconStatic('HELP'),
        // 'url'  : '/support',
        children: [
          {
            id: 'contact',
            title: 'Ticket request',
            translate: 'NAV.CONTACT.TITLE',
            type: 'item',
            // 'icon' : 'help',
            externalUrl: true,
            openInNewTab: true,
            url: 'https://gestiontraiteur.com/demande-de-ticket/', // prefix+AppRoutes.CONTACT,
          },
          {
            // Help Center V2 — visible to every role
            id: 'help-center',
            title: 'Help Center',
            translate: 'NAV.HELP_CENTER.TITLE',
            type: 'item',
            url: prefix + AppRoutes.KB,
          },
          {
            id: 'documentation',
            title: 'Knowledge base',
            translate: 'NAV.DOCUMENTATION.TITLE',
            type: 'item',
            // 'icon' : 'help',
            url: prefix + AppRoutes.DOCUMENTATION,
          },
          {
            id: 'release-note',
            title: 'Release notes',
            translate: 'NAV.RELEASE_NOTES.TITLE',
            type: 'item',
            // 'icon' : 'help',
            url: prefix + AppRoutes.RELEASE_NOTES,
          },
        ],
      },
      {
        id: 'platform',
        title: 'Platform',
        translate: 'NAV.PLATFORM.TITLE',
        type: 'collapsable',
        icon: 'smartphone',
        children: [
          {
            id: 'gtphoto-android',
            title: 'GT Photo Android',
            translate: 'NAV.GTPHOTO_ANDROID.TITLE',
            type: 'item',
            icon: 'android',
            externalUrl: true,
            openInNewTab: true,
            url: 'https://play.google.com/store/apps/details?id=com.gt.photo',
          },
          {
            id: 'gtphoto-ios',
            title: 'GT Photo iOS',
            translate: 'NAV.GTPHOTO_IOS.TITLE',
            type: 'item',
            icon: 'phone_iphone',
            externalUrl: true,
            openInNewTab: true,
            url: 'https://apps.apple.com/ca/app/gt-photo-from-mobile-to-shop/id6502609022',
          },
          {
            id: 'rms-magic-link',
            title: 'Management (RMS)',
            translate: 'NAV.RMS_MAGIC_LINK.TITLE',
            type: 'item',
            icon: 'launch',
            externalUrl: true,
            openInNewTab: true,
            url: '#',
          },
          {
            id: 'rms-magic-link-livraison',
            title: 'Delivery',
            translate: 'NAV.RMS_MAGIC_LINK_LIVRAISON.TITLE',
            type: 'item',
            icon: 'local_shipping',
            externalUrl: true,
            openInNewTab: true,
            url: '#',
          },
          {
            id: 'roadmap-magic-link',
            title: 'Roadmap',
            translate: 'NAV.ROADMAP_MAGIC_LINK.TITLE',
            type: 'item',
            icon: 'map',
            externalUrl: true,
            openInNewTab: true,
            url: '#',
          },
        ],
      },
    ],
  },
];
